module.exports = __webpack_public_path__ + "static/img/sspg_08.ead8adf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sspg/sspg_08.jpg
// module id = mmEw
// module chunks = 1